import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import socket from "../../../utils/socketConnect.utils";
import {
  fetchWhatsappChatsList,
  setLatestMessage,
  updateChatListWithUnReadCount,
} from "../../../store/slices/whatsappDataSlice";
import { IChatListItem } from "../../../models/Chat.model";
import { RootDispatch } from "../../../store";
import { useDispatch } from "react-redux";

interface ChatBubbleProps {
  chat: IChatListItem;
  handleSelectChat: (id: string) => void;
  selectedChatId: string;
  index: number;
}

const ChatListBubble: React.FC<ChatBubbleProps> = ({
  chat,
  handleSelectChat,
  selectedChatId,
  index,
}) => {
  const [unReadCounts, setUnReadCounts] = useState<number>(0);
  const [latestMsg, setLatestMsg] = useState<string>("");
  const dispatch: RootDispatch = useDispatch();

  useEffect(() => {
    setLatestMsg(chat.latestMessage?.message);

    setUnReadCounts(chat.unReadMessage);
    if (!socket.connected) socket.connect();

    const handleMessage = (msg: any) => {
      dispatch(setLatestMessage(msg?.latestMessage?._doc));
      setLatestMsg(msg?.latestMessage?._doc?.message);
      dispatch(fetchWhatsappChatsList());
    };

    socket.on("unreadCount" + chat._id, (msg) => {
      setUnReadCounts(msg?.unReadCount);
      dispatch(
        updateChatListWithUnReadCount({
          index,
          unReadCounts,
        })
      );
    });

    socket.on(chat._id, handleMessage);
    return () => {
      socket.off("unreadCount" + chat._id);
      socket.off(chat._id);
    };
  }, [
    dispatch,
    chat._id,
    chat.latestMessage?.message,
    chat.unReadMessage,
    setLatestMsg,
    setUnReadCounts,
    index,
    unReadCounts,
  ]);

  return (
    <div
      key={chat._id}
      onClick={() => handleSelectChat(chat._id)}
      className={`flex items-center p-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50 ${
        selectedChatId === chat._id
          ? "bg-green-50"
          : !chat?.latestMessage?.isSeen
          ? "bg-green-50/20"
          : ""
      }`}
    >
      <div className="relative rounded-full flex items-center justify-center text-white">
        <svg
          className="w-5 h-5"
          fill="black"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          ></path>
        </svg>
      </div>

      <div className="ml-3 flex-1">
        <div className="flex justify-between items-start">
          <span
            className={`font-medium ${
              !chat?.latestMessage?.isSeen ? "font-bold" : ""
            }`}
          >
            {chat?.receiver}
          </span>
          <div className="text-right">
            {chat?.latestMessage?.createdAt && (
              <span className="text-xs text-gray-500 block">
                {format(
                  new Date(chat?.latestMessage?.createdAt),
                  "dd/MM/yy hh:mm a"
                )}
              </span>
            )}
          </div>
        </div>
        <div className="flex justify-between items-start">
          <p
            className={`text-sm mt-1 truncate ${
              !chat?.latestMessage?.isSeen
                ? "text-gray-700 font-medium"
                : "text-gray-500"
            }`}
          >
            {latestMsg?.length > 30
              ? latestMsg.slice(0, 30) + "..."
              : latestMsg}
          </p>

          {unReadCounts > 0 && (
            <span className="text-xs text-white bg-green-500 px-1.5 py-0.5 rounded-full mt-1 inline-block">
              {unReadCounts}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatListBubble;
